import { PieChart, Pie, Cell, Tooltip, Label } from "recharts";
import styles from "./styles.module.scss";
import { Grid } from "antd";
interface DataItem {
  name: string;
  value: number;
}

const COLORS = [
  "#006AB3",
  "#F4BD00",
  "#429D41",
  "#F4BD00",
  "#F49F6F",
  "#33B2DF",
  "#76A974",
];

const { useBreakpoint } = Grid;

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const { name, value, fill } = payload[0].payload;
    const color = fill; // Get the corresponding color

    return (
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          padding: "10px",
          border: "1px solid #ccc",
        }}
      >
        <p style={{ color: color, fontSize: "14px", fontWeight: "600" }}>
          <strong>{name}:</strong> {value.toFixed(2)} Seconds
        </p>
      </div>
    );
  }

  return null;
};
export function PieChartGraph({ chartData, type }: any) {
  const screens = useBreakpoint();
  const totalObj = chartData?.find((item: any) => item.name === "Total Time");

  const totalTime = chartData.reduce((acc: number, item: DataItem) => {
    if (item.value !== null && item.value !== undefined) {
      return acc + item.value;
    }
    return acc;
  }, 0);

  const width = type === "preview" ? (screens.xxl ? 300 : 200) : 800;
  const height = type === "preview" ? (screens.xxl ? 230 : 140) : 400;
  const innerRadius = type === "preview" ? (screens.xxl ? 55 : 40) : 80;
  const outerRadius = type === "preview" ? (screens.xxl ? 90 : 60) : 150;
  const cx = type === "preview" ? (screens.xxl ? 150 : "50%") : 600;
  const cy = type === "preview" ? (screens.xxl ? 90 : "50%") : 180;

  const legendBoxClass =
    type === "preview" ? styles.legendBoxPreview : styles.legendBox;

  const labelClass =
    type === "preview" ? styles.centerlabelPreview : styles.centerlabel;
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          padding: 0,
        }}
      >
        <PieChart width={width} height={height}>
          <Pie
            data={chartData?.filter((item: any) => item.name !== "Total Time")}
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            fill="#8884d8"
            paddingAngle={5}
            isAnimationActive={true}
            dataKey="value"
            label={false}
          >
            {chartData
              ?.filter((item: any) => item.name !== "Total Time")
              .map((entry: any, index: any) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            <Label
              value="Total Time"
              position="centerBottom"
              className="label"
              fontSize={screens.xxl ? "15px" : "12px"}
            />
            <Label
              value={`${totalObj?.value?.toFixed(2)} Secs`}
              position="centerTop"
              className={styles["label-top"]}
              fontSize={screens.xxl ? "15px" : "12px"}
              fontWeight="bold"
            />
          </Pie>
          <Tooltip
            content={<CustomTooltip total={totalTime} colors={COLORS} />}
            wrapperStyle={{ zIndex: 999 }} // Add wrapperStyle prop to ensure tooltip visibility
          />
        </PieChart>
      </div>

      <div className={styles.legendContainer}>
        <div className={legendBoxClass}>
          {chartData
            ?.filter((item: any) => item.name !== "Total Time")
            .map((entry: any, index: any) => (
              <div key={`legend-${index}`} className={styles.legendEntry}>
                <div
                  className={styles.legendColor}
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                ></div>
                <span className={styles.legendText}>{entry.name}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
